var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "drip-campaign-clients", "modal-dialog-size": "lg" },
    on: {
      hide: function ($event) {
        return _vm.$emit("hide", $event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", [
              _c(
                "h5",
                { staticClass: "bold" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("drip-campaigns.actions.clientsWithin")) +
                      "\n        "
                  ),
                  _c("refresh-button", {
                    attrs: { loading: _vm.refreshing },
                    on: { refresh: _vm.handleRefresh },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("drip-campaign-clients-table", {
              ref: "upcomingTable",
              attrs: { "campaign-id": _vm.campaignId },
              on: {
                loading: function ($event) {
                  _vm.refreshing = $event
                },
                "delete-client": _vm.handleDeleteClient,
                "clients-deleted": _vm.handleBulkDeleteClients,
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }